import React from 'react';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { useBeaconClientId } from 'src/utils/Hooks/reduxSelectors';
import { BEACON_TABS, BEACON_SUBTABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import ButtonDropdown from './ButtonDropdown';

interface ContentOptionsDropdownProps {
  stacklineSku: string;
}

const ContentOptionsDropdown: React.FC<ContentOptionsDropdownProps> = ({ stacklineSku }) => {
  const { beaconNavigator } = useBeaconNavigator();
  const beaconClientId = useBeaconClientId();

  const getMenuOptions = () => {
    const options = [
      {
        id: 'viewGeneratedContent',
        label: 'View generated content'
      }
    ];

    return options;
  };

  const handleOptionSelect = () => {
    beaconNavigator.setPathname(`/client/${beaconClientId}/generate`);
    beaconNavigator.updateSearchParams({
      tab: BEACON_TABS.LIBRARY,
      subtab: BEACON_SUBTABS.LIBRARY,
      sku: stacklineSku
    });
    beaconNavigator.go();
  };

  return (
    <ButtonDropdown
      label="+ Generate Content"
      options={getMenuOptions()}
      onChange={handleOptionSelect}
      variant="contained"
    />
  );
};

export default ContentOptionsDropdown;
